import { Injectable } from '@angular/core';
import { BaseService } from '@common';

/**
 * 分享/标记原因管理服务
 *
 * 获取试卷分享和标记（原收藏）的原因列表，使用 localStorage 缓存（当天有效），
 * 避免重复请求。后端约定 value 以 1xx 开头为优秀，2xx 开头为较差。
 */
@Injectable()
export default class ShareReasonService extends BaseService {
  /**
   * 获取分享原因列表
   *
   * 返回值示例：
   * ```
   * [
   *   [100, "优秀示范"],
   *   [201, "典型错误"]
   * ]
   * ```
   *
   * @returns 元组数组，[value, label]，value 含义同后端的 flag 值
   */
  async getShareReasons(): Promise<[number, string][]> {
    return this.getItem<[number, string][]>(
      'mark_share_flag_reasons',
      () => {
        return this.doGet<[number, string][]>('/papers/exercise/details/share-flag/');
      },
      'today'
    );
  }
}
